import { enqueueSnackbar, DownloadFile, UploadMultipleFiles } from 'actions';

import {
	GetIncidentTableRequest,
	GetDropdownsRequest,
	GetAllDropdownsRequest,
	GetProjectsDropdownRequest,
	GetSowDropdownRequest,
	GetLayersDropdownRequest,
	GetIncidentBaseRequest,
	GetIncidentRequest,
	GetTypeDropdownRequest,
	GetDetailedTypeDropdownRequest,
	CreateIncidentRequest,
	EditIncidentRequest,
	ExportIncidentsRequest,
	GetIncidentCommentsRequest,
	GetIncidentFilesRequest
} from '../requests/IncidentTrackerRequests.js';

export const GET_INCIDENT_TABLE = 'GET_INCIDENT_TABLE';
export const TOGGLE_INCIDENT_TRACKER_DIALOG = 'TOGGLE_INCIDENT_TRACKER_DIALOG';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const SET_CURRENT_QUEUE_DROPDOWN = 'SET_CURRENT_QUEUE_DROPDOWN';
export const GET_DROPDOWNS = 'GET_DROPDOWNS';
export const GET_ALL_DROPDOWNS = 'GET_ALL_DROPDOWNS';
export const GET_PROJECTS_DROPDOWN = 'GET_PROJECTS_DROPDOWN';
export const GET_SOW_DROPDOWN = 'GET_SOW_DROPDOWN';
export const GET_LAYERS_DROPDOWN = 'GET_LAYERS_DROPDOWN';
export const GET_INCIDENT = 'GET_INCIDENT';
export const GET_TYPE_DROPDOWN = 'GET_TYPE_DROPDOWN';
export const GET_DETAILED_TYPE_DROPDOWN = 'GET_DETAILED_TYPE_DROPDOWN';
export const GET_INCIDENT_COMMENTS = 'GET_INCIDENT_COMMENTS';
export const GET_INCIDENT_FILES = 'GET_INCIDENT_FILES';
export const SET_FILES = 'SET_FILES';
export const SET_IMAGE = 'SET_IMAGE';

const onGetIncidentTable = (value) => ({
	type: GET_INCIDENT_TABLE,
	incidentTable: value
});

export const GetIncidentTable = () => async (dispatch) => {
	await GetIncidentTableRequest().then(response => {
		dispatch(onGetIncidentTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleIncidentTrackerDialog = (visible, incidentId, incidentSubmitter) => ({
	type: TOGGLE_INCIDENT_TRACKER_DIALOG,
	visible,
	incidentId,
	incidentSubmitter
});

export const ToggleIncidentTrackerDialog = (visible, incidentId, incidentSubmitter) => (dispatch) => {
	dispatch(onToggleIncidentTrackerDialog(visible, incidentId, incidentSubmitter));
};

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

const onSetFiles = (value) => ({
	type: SET_FILES,
	files: value
});

export const SetFiles = (value) => (dispatch) => {
	dispatch(onSetFiles(value));
};

const onSetImage = (value) => ({
	type: SET_IMAGE,
	image: value
});

export const SetImage = (value) => (dispatch) => {
	dispatch(onSetImage(value));
};

const onSetCurrentQueueDropdown = (value) => ({
	type: SET_CURRENT_QUEUE_DROPDOWN,
	currentQueueDropdown: value
});

export const SetCurrentQueueDropdown = (value) => (dispatch) => {
	dispatch(onSetCurrentQueueDropdown(value));
};

const onGetDropdowns = (value) => ({
	type: GET_DROPDOWNS,
	dropdowns: value
});

export const GetDropdowns = () => async (dispatch) => {
	await GetDropdownsRequest().then(response => {
		dispatch(onGetDropdowns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetAllDropdowns = (value) => ({
	type: GET_ALL_DROPDOWNS,
	allDropdowns: value
});

export const GetAllDropdowns = (incidentId) => async (dispatch) => {
	await GetAllDropdownsRequest(incidentId).then(response => {
		dispatch(onGetAllDropdowns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetProjectsDropdown = (value) => ({
	type: GET_PROJECTS_DROPDOWN,
	projectsDropdown: value
});

export const GetProjectsDropdown = (siteId) => async (dispatch) => {
	await GetProjectsDropdownRequest(siteId).then(response => {
		dispatch(onGetProjectsDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSowDropdown = (value) => ({
	type: GET_SOW_DROPDOWN,
	sowDropdown: value
});

export const GetSowDropdown = (siteId, project) => async (dispatch) => {
	await GetSowDropdownRequest(siteId, project).then(response => {
		dispatch(onGetSowDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetLayersDropdown = (value) => ({
	type: GET_LAYERS_DROPDOWN,
	layersDropdown: value
});

export const GetLayersDropdown = (techs) => async (dispatch) => {
	await GetLayersDropdownRequest(techs).then(response => {
		dispatch(onGetLayersDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetTypeDropdown = (value) => ({
	type: GET_TYPE_DROPDOWN,
	typeDropdown: value
});

export const GetTypeDropdown = (genericType) => async (dispatch) => {
	await GetTypeDropdownRequest(genericType).then(response => {
		dispatch(onGetTypeDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetDetailedTypeDropdown = (value) => ({
	type: GET_DETAILED_TYPE_DROPDOWN,
	detailedTypeDropdown: value
});

export const GetDetailedTypeDropdown = (type) => async (dispatch) => {
	await GetDetailedTypeDropdownRequest(type).then(response => {
		dispatch(onGetDetailedTypeDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetIncident = (value) => ({
	type: GET_INCIDENT,
	incident: value
});

export const GetIncidentBase = (siteId, project, sow) => async (dispatch) => {
	await GetIncidentBaseRequest(siteId, project, sow).then(response => {
		dispatch(onGetIncident(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetIncident = (incidentId) => async (dispatch) => {
	await GetIncidentRequest(incidentId).then(response => {
		dispatch(onGetIncident(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetIncidentComments = (value) => ({
	type: GET_INCIDENT_COMMENTS,
	incidentComments: value
});

export const GetIncidentComments = (incidentId) => async (dispatch) => {
	await GetIncidentCommentsRequest(incidentId).then(response => {
		dispatch(onGetIncidentComments(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetIncidentFiles = (value) => ({
	type: GET_INCIDENT_FILES,
	incidentFiles: value
});

export const GetIncidentFiles = (incidentId) => async (dispatch) => {
	await GetIncidentFilesRequest(incidentId).then(response => {
		dispatch(onGetIncidentFiles(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const CreateIncident = (incidentForm) => async (dispatch) => {
	await CreateIncidentRequest(incidentForm).then(response => {
		dispatch(enqueueSnackbar({ message: 'Incident successfully created.', options: { variant: 'success' } }));
		GetIncidentTable();
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadFilesAndCreateIncident = (incidentForm, files) => async (dispatch) => {
	await UploadMultipleFiles(files).then(response => {
		dispatch(CreateIncident({ ...incidentForm, files: response.data }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditIncident = (incidentForm) => async (dispatch) => {
	await EditIncidentRequest(incidentForm).then(response => {
		dispatch(enqueueSnackbar({ message: 'Incident successfully edited.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadFilesAndEditIncident = (incidentForm, files) => async (dispatch) => {
	await UploadMultipleFiles(files).then(response => {
		dispatch(EditIncident({ ...incidentForm, files: response.data }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ExportIncidents = () => async (dispatch) => {
	await ExportIncidentsRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
